import { useClientConfigProvider } from "@/app/config/client-config-provider";
import { useMixPanel } from "@/app/context/mixPanelContext";
import { useAppContext } from "@thriwe-2-0/thriwe-ui-utils";
import { useRouter } from "next/navigation";
import { ReactNode, RefObject } from "react";
import Image from "next/image";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import HTMLReactParser from "html-react-parser/lib/index";
import AppRoutes from "@/app/constants/routes";

export const WebUI = ({
  children,
  placeHolderText,
  signUpForm,
  buttonRef,
  handleDivClick,
}: {
  children?: ReactNode;
  placeHolderText?: string;
  signUpForm?: any;
  buttonRef?: RefObject<HTMLButtonElement>;
  handleDivClick?: Function;
}) => {
  const context = useAppContext();
  const { trackEvent } = useMixPanel();
  const {
    instances: { apiRepository },
    state: { isMobile },
    setUser,
    fetchUserProfile,
  } = context;
  const { config, getImagePath, StringConstantsInstance } =
    useClientConfigProvider();
  const router = useRouter();
  const { t } = useTranslation();

  return (
    <div className="login-screen-desktop-v2">
      <div className="left-login-desktop-container display_desktop">
        <Image
          className="left-panel-login-register-background"
          alt=""
          src={getImagePath("v2/login/login_bg.webp")}
          height={1024}
          width={1440}
        />
        <div
          className="brand-logo-container"
          onClick={() => router.push(AppRoutes.landing)}
        >
          <Image
            className="brand-logo-image"
            src={getImagePath("logo-white.png")}
            alt={"brand_logo"}
            height={39}
            width={0}
            style={{ width: "auto", cursor: "pointer" }}
          />
        </div>
        <div className="brand-tagline-container">
          <div className="heading-v2">
            {HTMLReactParser(t("loginV2.leftSectionText"))}
          </div>
        </div>
        {/* <div
          className="bottom-image-container"
          style={{
            width: "100%",
            zIndex: 1,
          }}
        >
          <Image
            className="benefits-bottom-banner-image"
            src={getImagePath(
              "v2/login/login-left-container-bottom-image.webp"
            )}
            alt={"benefits banner"}
            style={{ width: "100%", objectFit: "fill" }}
            height={287}
            width={810}
          />
        </div> */}
      </div>
      {children}
    </div>
  );
};
